export default {
  path: '/404',
  component: () => import('./404')
};
